<template>
  <Notifiche10Giorni
    :follow-up-days="24"
    page-title="Notifiche 24 giorni"
    page-subtitle="Promemoria generati dalla consegna programmi a 24 giorni."
  />
</template>

<script>
import Notifiche10Giorni from './Notifiche10Giorni.vue';

export default {
  name: 'Notifiche24Giorni',
  components: {
    Notifiche10Giorni,
  },
};
</script>
